import { addressContainer, footerContainer, footerInfoContainer, footerInfoHeadline, lastContainer } from './styles';
import { StaticImage } from 'gatsby-plugin-image';
import {FlexBox} from '@ui';
import settings from '@settings';
import { Link } from 'gatsby';

const Footer = () => {
	
	return (
		<div css={footerContainer}>
			<FlexBox direction='column' align='center' justify='space-between' gap={settings.sizes.extraLarge} styles={{padding: settings.padding.large, backgroundColor: settings.colors.dark}}>
				<FlexBox direction='column' align='center' gap={settings.sizes.large}>
					<StaticImage height={60} src={'./images/patwork_logo_white.png'} alt='Saaman Diagnostik' />
					<p>
						Bringt Sie in die Digitale Welt seit 2018
					</p>
				</FlexBox>
				<div css={addressContainer}>
					<div css={footerInfoContainer}>
						<p css={footerInfoHeadline}>E-Mail</p>
						<a href='mail:info@patwork.net'>
							info@patwork.net
						</a>
					</div>
					<div css={footerInfoContainer}>
						<p css={footerInfoHeadline}>Adresse</p>
						<p>
							Bergmannsweg 5 <br />
							79111 Freiburg <br />
							Deutschland
						</p>
					</div>
				</div>
			</FlexBox>
			<div css={lastContainer}>
				<div css={{display: 'flex', gap: settings.sizes.small,}}>
					<Link to='/impressum'>Impressum</Link> 
					<p>|</p> 
					<Link to='/datenschutz'>Datenschutz</Link> 
				</div>

				<div>
					<p>
						patwork @ {new Date().getFullYear()}
					</p>
				</div>
			
			</div>
		</div>
	);
};

export default Footer;